import { RefreshCcwIcon } from "lucide-react";

import { Button } from "@/components/ui/ButtonNew";
import {
  ErrorScreenLayout,
  ErrorScreenPanel,
} from "@/components/ui/errors/error-screen-layout";

import somethingWrongImageSecondary from "./assets/something-wrong-1.svg";
import somethingWrongImagePrimary from "./assets/something-wrong.svg";

const SOMETHING_WRONG_IMAGES = [
  somethingWrongImagePrimary,
  somethingWrongImageSecondary,
] as const;

export interface SomethingWentWrongProps {
  fullPage?: boolean;
  message?: string;
  className?: string;
  onReload?: () => void;
}

const DEFAULT_MESSAGE =
  "Looks like there were some hiccups. Let’s try that again";

export function SomethingWentWrong({
  fullPage = false,
  message = DEFAULT_MESSAGE,
  className,
  onReload,
}: SomethingWentWrongProps) {
  const handleReload = onReload ?? (() => window.location.reload());

  return (
    <ErrorScreenLayout
      fullPage={fullPage}
      className={className}
      message={message}
      images={SOMETHING_WRONG_IMAGES}
      action={
        <Button
          variant="vibrant"
          onClick={handleReload}
          className="h-auto min-h-0 gap-2 rounded-lg px-16 py-3 text-base font-normal shadow-none hover:shadow-none active:shadow-none"
        >
          Refresh
          <RefreshCcwIcon
            className="size-4 shrink-0 stroke-[2.5]"
            aria-hidden
          />
        </Button>
      }
    />
  );
}

export function SomethingWentWrongPanel({
  className,
  ...props
}: SomethingWentWrongProps) {
  return (
    <ErrorScreenPanel className={className}>
      <SomethingWentWrong {...props} className="shrink-0 py-0" />
    </ErrorScreenPanel>
  );
}
